<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;" mat-raised-button color="primary"
          printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
          Print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    <div class="print-container" id="print-section">
        <div style="text-align: center; font-weight: bold; font-size: xx-large; margin-bottom: 15px;">
          जाहिरातदार पत्ते यादी
        </div>
      
        <div style="display: flex; justify-content: space-between; width: 100%; font-weight: bold; margin-bottom: 20px;">
          <!-- <span style="text-align: left; font-size: small;">अंक दिनांक :- {{ issueDates | date: 'dd-MM-yyyy' }}</span> -->
          <span style="text-align: right;margin-left: 70px;">दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</span>
        </div>
      
       <table class="advt-table">
  <thead>
    <tr>
      <th class="col-name">प्रतिनिधी</th>
      <th class="col-place">ठिकान</th>
      <th class="col-phone">दुरध्वनी</th>
      <th class="col-net">निव्वळ रक्कम</th>
      <th class="col-rcv">जमा रक्कम</th>
      <th class="col-bal">येणे बाकी</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let data1 of Address">
      <td class="col-name">{{ data1.advt_name | slice : 0:35 }}</td>
      <td class="col-place">{{ data1.taluka }} - {{ data1.district}}</td>
      <td class="col-phone">{{ data1.advt_mobile }}</td>
      <td class="col-net" style="text-align: right;">{{ data1.net_amt }}</td>
      <td class="col-rcv" style="text-align: right;">{{ data1.rcv_amt }}</td>
      <td class="col-bal" style="text-align: right;">{{ data1.balance_amt }}</td>
    </tr>
  </tbody>
</table>

    </div>
</div>